// extracted by mini-css-extract-plugin
export var container = "_ca-0";
export var containerTopRight = "_ca-1";